import { useValueAsStream, useDataStream } from 'annotation-tools/utils';

export const useValueAsDataStream = <T>(value: T) => {
  const stream = useValueAsStream(value);
  const dataStream = useDataStream(value, stream);
  return dataStream;
};
